import React  from 'react';
import Icon from '@mdi/react';
import { mdiChevronLeft } from '@mdi/js';
import { useHistory } from 'react-router-dom';
import './FormulaBanner.scss';

interface IFormulaBannerProps {
  title: string;
  help: any;
  noFooter?:boolean;
}

export const FormulaBanner = (props: IFormulaBannerProps) => {
  const history = useHistory();
  return (
    <div className="subtitle-intro-banner">
      <h1>{props.title}</h1>
      {props.noFooter ? null : 
      <div className="banner-footer">
        <button
          className="usa-button usa-button--unstyled banner-back-button"
          onClick={() => {
            history.push('/analysis/hydraulic-formula');
          }}
        >
          <Icon path={mdiChevronLeft} size={1.2} color={'#fff'} />
          Back
        </button>
      </div>
   }
    </div>
  );
};
